export var cardBorder = '$_1Uvai';
export var maxWidthBullets = '$_1V3Kh';